import {LOGIN, LOGOUT, ALGO_ERRADO} from '../constants/constants'
import {Map} from 'immutable'

export default (loginState=Map({algoErrado:false}), action) => {

    if(action.type===LOGIN){
        return loginState.set('usuario', action.usuario)
    }
    if(action.type===LOGOUT){
        return loginState.set('usuario', undefined)
    }
    if(action.type===ALGO_ERRADO){
        return loginState.set('algoErrado', action.data)
    }

    return loginState
}


// WEBPACK FOOTER //
// ./src/reducers/login.js